import { mutatorAction } from 'satcheljs';
import { getCopilotChatDrawerState } from '../store/store';

export const setUserPreferredWidthMutator: (targetWindow: Window, width: number) => void =
    mutatorAction('setUserPreferredWidthMutator', (targetWindow: Window, width: number): void => {
        const state = getCopilotChatDrawerState(targetWindow);
        if (!state) {
            return;
        }
        state.userPreferredWidth = width;
    });
